// extracted by mini-css-extract-plugin
module.exports = {"container":"Resource_container__1Suwr","loading":"Resource_loading__3PXxF","loader":"Resource_loader__2pI5c","errorState":"Resource_errorState__3hOhS"};